<template>
  <div>
    <div class="time-show-over" style="visibility:hidden;">
      <div style="position:fixed;top:0;bottom:0;left:0;right:0;opacity:0.9; background-color:#444;">
      </div>
      <div style="display:flex; flex-direction:column;align-items:center; justify-content:center;
      position:fixed;top:0;bottom:0;left:0;right:0;">
        <span style="font-size:20px;color:#fff;margin-bottom:30px;">本次训练已结束</span>
        <mu-raised-button @click="close" label="确定" style="border-radius:40px;" class="dialog-btn" primary />
      </div>
    </div>
    <div id="timer">
      <mu-circular-progress mode="determinate" :size="120" :strokeWidth="10" :value="timerAll"
      color="#ddd" class="timer-modify"/>
      <mu-circular-progress mode="determinate" :size="120" :strokeWidth="10" :value="tmvalue" :min="0" :max="tmMaxValue" color="#0A81E5" class="timer-modify"/>
      <div class="timer-icon">
        <span>{{oddSecond | timer}}</span>
        <span v-if="showPlayType" @click="timerPause" >
          <mu-icon v-show="showPause" value="pause" color="blue" :size="40" />
        </span>
        <span v-else @click="timerPlay">
          <mu-icon v-show="showPlay" value="play_arrow" color="blue" :size="40" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    props: ['caseId','time', 'tmID'],
    data () {
      return {
        isEnd:'normal',
        showPlayType: true,
        showClick: false, // 是否允许点击时间
        showPause: true,
        showPlay: true,
        defaultTime: this.time/60,//初始化传入秒数
        oddSecond:0,  //剩余秒数
        tmvalue: 0,   //时钟圆环进度条实时值
        tmMaxValue:0,//时钟圆环进度条峰值
        heartBeat: null, // 心跳计时器
        timer:null,   //计时器对象
        timerAll: parseInt(this.time)  // 总进度数
      }
    },
    filters:{
      //自定义过滤器，过滤毫秒为日期格式
      timer:function(value) {
        let data = value/60;
        let m = Math.floor(data);
        let s = Math.round((data-m)*60);
        if(m < 10){
          m = '0'+ m;
        }
        if(s < 10){
          s = '0'+ s;
        }
        return m+":"+s;
      },
      timer2:function(value) {
        let data = value/60;
        let m = Math.floor(data);
        let s = Math.round((data-m)*60);
        if(m < 10){
          m = '0'+ m;
        }
        if(s < 10){
          s = '0'+ s;
        }
        return m+"分"+s+"秒";
      }
      //end过滤器
    },
    mounted () {
      this.timerStart();
    },
    beforeDestroy () {
      clearInterval(this.timer)
      clearInterval(this.heartBeat);
    },
    methods: {
      timerPlay(){
        this.showPlayType = true;
        this.showPlay = false;
        this.$http.post('/api/Train/playTM',{
          patient_uuid: this.caseId,
          'tm_id': this.tmID
        },{emulateJSON: false})
        .then((res)=>{
          this.showPlay = true;
          this.$emit("showClick",true)
          if(res.body.left > 0){
            this.timerMachineRestart()
          } else {
            $(".time-show-over").css("visibility","");
            $("#timer").css("z-index","-1")
            clearInterval(this.timer);
            clearInterval(this.heartBeat);
          }
        })
      },
      timerPause(){
        this.showPlayType = false;
        this.showPause = false;
        this.$http.post('/api/Train/pauseTM',{
          patient_uuid: this.caseId,
          'tm_id': this.tmID
        },{emulateJSON: false})
        .then((res)=>{
          this.showPause = true;
          this.$emit("showClick",false)
          clearInterval(this.timer);
          clearInterval(this.heartBeat);
        })
      },
      close(){
        window.history.back();
      },
      closeGame(){
        this.$http.post('/api/Train/finishTM',{
          patient_uuid: this.caseId,
          'tm_id': this.tmID
        },{emulateJSON: false})
        .then((res)=>{
          console.log(res)
        })
      },
      timerMachineContinue(){//继续倒计时
        var self = this;
        $(".time-show-over").css("visibility","hidden");
        $("#timer").css("z-index","0")
        self.isEnd = 'normal';
        self.timerMachineRestart();
      },
      timerMachineRestart(){//时间机器，每秒执行一次
        var self = this;
        clearInterval(self.timer);
        self.timer = setInterval(() => {  //倒计时，每秒执行一次
          self.tmvalue += 1;    //进度条每秒加1
          self.oddSecond -= 1;//执行次数每秒减1
          if (self.oddSecond <= 0){
            //小于0则清除计时器，显示训练结束
            $(".time-show-over").css("visibility","");
            $("#timer").css("z-index","-1")
            clearInterval(self.timer);
            clearInterval(self.heartBeat);
            self.closeGame();
            self.$emit("timeOver")
          }
        }, 1000)

        clearInterval(self.heartBeat);
        self.heartBeat = setInterval(()=>{
          if (self.oddSecond <= 0){
            //小于0则清除计时器，显示训练结束
            clearInterval(self.heartBeat);
          } else {
            // 每分钟发一次心跳
            this.$http.post('/api/Train/playTM',{
              patient_uuid: this.caseId,
              'tm_id': this.tmID
            },{emulateJSON: false})
          }
        },60000)
      },
      timerStart(){
        var self = this;
        self.tmMaxValue = self.defaultTime*60;//初始化设置进度条最大值
        self.oddSecond = self.defaultTime*60;//剩余秒数
        self.timerMachineRestart();
      }
    }
  }
</script>

<style lang="css">
  .timer-stop{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .dialog-btn{
    width:120px;
    height:40px;
    font-size:16px;
  }
  /*timer*/
  #timer{
    width:120px;
    height:120px;
    position:relative;
    bottom:0px;
    right:50px;
    z-index: 0;
  }
  .mu-circular-progress{
    position:absolute!important;
  }
  .timer-icon{
    position:absolute;
    top:32px;
    right:28px;
  }
  .timer-icon span{
    color:#0A81E5;
    font-size:24px;
    color:#333;
    display:block;
    text-align:center;
  }
  .timer-icon span:last-child{
    color:#0A81E5;
    font-weight:bold;
    font-size:26px;
    cursor:pointer;
  }
  .timer-modify{
    transform: rotate(-90deg);
  }
</style>



// WEBPACK FOOTER //
// Ticker.vue?6c6c701c